"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.initDevice = exports.makeDevice = exports.getModel = exports.models = exports.Device = exports.identities = exports.NAMESPACE = exports.Util = exports.FailureMode = exports.SlottedConsumable = exports.SyncRo = exports.Pelican2 = exports.HydroTapBridge = exports.Gbfc = exports.Common = exports.Blackbox = exports.Base = exports.ActiveAlarm = void 0;
const effect_1 = require("effect");
const Blackbox = __importStar(require("./blackbox"));
const Gbfc = __importStar(require("./gbfc"));
const HydroTapBridge = __importStar(require("./hydrotap-bridge"));
const Pelican2 = __importStar(require("./pelican2"));
const SyncRo = __importStar(require("./sync-ro"));
exports.ActiveAlarm = __importStar(require("./active-alarm"));
exports.Base = __importStar(require("./base"));
exports.Blackbox = __importStar(require("./blackbox"));
exports.Common = __importStar(require("./common"));
exports.Gbfc = __importStar(require("./gbfc"));
exports.HydroTapBridge = __importStar(require("./hydrotap-bridge"));
exports.Pelican2 = __importStar(require("./pelican2"));
exports.SyncRo = __importStar(require("./sync-ro"));
exports.SlottedConsumable = __importStar(require("./slotted-consumable"));
exports.FailureMode = __importStar(require("./failure-mode"));
exports.Util = __importStar(require("./_util"));
exports.NAMESPACE = 'Culligan.Device.Class';
exports.identities = {
    Blackbox: Blackbox.Blackbox,
    Gbfc: Gbfc.Gbfc,
    HydroTapBridge: HydroTapBridge.HydroTapBridge,
    Pelican2: Pelican2.Pelican2,
    SyncRo: SyncRo.SyncRo,
};
exports.Device = effect_1.Schema.Union(...effect_1.Record.values(exports.identities)).annotations({
    identifier: `${exports.NAMESPACE}.Device`,
});
/**
 * Exhaustive map of each {@link Common.ModelCode ModelCode} to its constructor
 */
exports.models = {
    [Blackbox.Blackbox.code]: Blackbox.Blackbox,
    [Gbfc.Gbfc.code]: Gbfc.Gbfc,
    [HydroTapBridge.HydroTapBridge.code]: HydroTapBridge.HydroTapBridge,
    [Pelican2.Pelican2.code]: Pelican2.Pelican2,
    [SyncRo.SyncRo.code]: SyncRo.SyncRo,
};
/**
 * Returns the device constructor based on the given model code.
 */
const getModel = (modelCode) => exports.models[modelCode];
exports.getModel = getModel;
/**
 * Given any generic device, construct it into a known device model.
 *
 * This can fail if the properties of the generic device aren't assignable to
 * the properties of the model it says it represents. You'll get a ParseError
 * containing the specific violation.
 */
const makeDevice = (props) => {
    const ctr = (0, exports.getModel)(props.model);
    // We're narrowing the props of AnyDevice into the specific device class.
    try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return effect_1.Either.right(new ctr(props));
    }
    catch (e) {
        if (effect_1.ParseResult.isParseError(e)) {
            return effect_1.Either.left(e);
        } /* v8 ignore start */
        else {
            throw e;
        } /* v8 ignore end */
    }
};
exports.makeDevice = makeDevice;
/**
 * Generically initialize a device using underlying `init` constructors.
 *
 * This can fail if the generic initialization properties aren't assignable to
 * the properties of the specific model that's being initialized. You'll get a
 * ParseError containing the specific violation.
 */
const initDevice = (modelCode, props, time) => {
    const ctr = (0, exports.getModel)(modelCode);
    try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return effect_1.Either.right(ctr.init(props, time));
    }
    catch (e) {
        if (effect_1.ParseResult.isParseError(e)) {
            return effect_1.Either.left(e);
        } /* v8 ignore start */
        else {
            throw e;
        } /* v8 ignore end */
    }
};
exports.initDevice = initDevice;
//# sourceMappingURL=index.js.map